import { useFloorplanDesignStore } from '@/modules/floorplanDesign/store/useFloorplanDesignStore';
import { useCanvasStore } from '@/modules/canvas/store';

import { useActiveFlowStore } from '../store/useActiveFlowStore';
import { IFlowService } from './IFlowService';
import { FlowServiceExceptionDecorator } from './FlowServiceExceptionDecorator';
import { FlowServiceHistoryDecorator } from './FlowServiceHistoryDecorator';
import { FlowServiceLogDecorator } from './FlowServiceLogDecorator';
import { FlowServiceImpl } from './FlowServiceImpl';

export class FlowServiceFactory {
  private static instance: FlowServiceFactory | null = null;
  private floorplanDesignStore: typeof useFloorplanDesignStore;
  private canvasStore: typeof useCanvasStore;
  private activeFlowStore: typeof useActiveFlowStore;

  public static initialize(
    floorplanDesignStore: typeof useFloorplanDesignStore,
    canvasStore: typeof useCanvasStore,
    activeFlowStore: typeof useActiveFlowStore,
  ) {
    FlowServiceFactory.instance = new FlowServiceFactory(
      floorplanDesignStore,
      canvasStore,
      activeFlowStore,
    );
  }

  public static getInstance() {
    if (FlowServiceFactory.instance === null) {
      throw new Error(
        'FlowServiceFactory not yet initialized. Call FlowServiceFactory.initialize() first.',
      );
    }
    return FlowServiceFactory.instance;
  }

  private constructor(
    floorplanDesignStore: typeof useFloorplanDesignStore,
    canvasStore: typeof useCanvasStore,
    activeFlowStore: typeof useActiveFlowStore,
  ) {
    this.floorplanDesignStore = floorplanDesignStore;
    this.canvasStore = canvasStore;
    this.activeFlowStore = activeFlowStore;
  }

  public createFlowService(): IFlowService {
    let result: IFlowService = this.makeFlowService();

    result = new FlowServiceExceptionDecorator(result);
    result = new FlowServiceHistoryDecorator(result);
    result = new FlowServiceLogDecorator(result);

    return result;
  }

  private makeFlowService(): IFlowService {
    return new FlowServiceImpl(this.floorplanDesignStore, this.canvasStore, this.activeFlowStore);
  }
}
